import React from 'react';
import InstanceDetailSlideout from '../InstanceDetailSlideout';
import GroupDetailSlideout from '../GroupDetailSlideout';
import InstanceTarget from '../../../types/instance/InstanceTarget';
import HostTarget from '../../../types/host/HostTarget';

interface DashboardSlideoutsProps {
    selectedInstanceWithMetrics: InstanceTarget | null;
    selectedHostDetails: HostTarget | null;
    handleInstanceSlideoutClose: () => void;
    selectedGroupName: string | null;
    hosts: HostTarget[];
    selectedGroupInstances: InstanceTarget[] | null;
    handleGroupSlideoutClose: () => void;
    applyPeriod: Function
}

const DashboardSlideouts: React.FC<DashboardSlideoutsProps> = ({
    selectedInstanceWithMetrics,
    selectedHostDetails,
    handleInstanceSlideoutClose,
    selectedGroupName,
    selectedGroupInstances,
    handleGroupSlideoutClose,
    hosts,
    applyPeriod
}) => {
    const showInstanceOffcanvas = selectedInstanceWithMetrics !== null;
    const showGroupOffcanvas = selectedGroupName !== null && selectedGroupInstances !== null;

    return (
        <>
            {/* Instance Detail Slideout */}
            <div
                className={`offcanvas offcanvas-end instance-detail-slideout ${showInstanceOffcanvas ? 'show' : ''}`}
                tabIndex={-1}
                id="instanceDetailOffcanvas"
                aria-labelledby="instanceDetailOffcanvasLabel"
                style={{ width: '65vw', visibility: showInstanceOffcanvas ? 'visible' : 'hidden' }}
                data-bs-backdrop="static"
            >
                <div className="offcanvas-body p-0">
                    {selectedInstanceWithMetrics && (
                        <InstanceDetailSlideout
                            instance={selectedInstanceWithMetrics}
                            hostDetails={selectedHostDetails}
                            onClose={handleInstanceSlideoutClose}
                            applyPeriod={applyPeriod}
                        />
                    )}
                </div>
            </div>

            {/* Group Detail Slideout */}
            <div
                className={`offcanvas offcanvas-end group-detail-slideout ${showGroupOffcanvas ? 'show' : ''}`}
                tabIndex={-1}
                id="groupDetailOffcanvas"
                aria-labelledby="groupDetailOffcanvasLabel"
                style={{ width: '75vw', visibility: showGroupOffcanvas ? 'visible' : 'hidden' }}
            >
                <div className="offcanvas-body p-0">
                    {selectedGroupName && selectedGroupInstances && (
                        <GroupDetailSlideout
                            groupName={selectedGroupName}
                            hosts={hosts}
                            instances={selectedGroupInstances.sort((a, b) => a.name.localeCompare(b.name))}
                            onClose={handleGroupSlideoutClose}
                            applyPeriod={applyPeriod}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default DashboardSlideouts; 